'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var ReactModal2 = require('react-modal2').default;

var _require = require('react-gateway');

var Gateway = _require.Gateway;

var ReactCSSTransitionGroup = require('react-addons-css-transition-group');

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Modal.prototype.render = function render() {
    var modalClassName = 'cf-modal';

    if (this.props.type === 'confirm') {
      modalClassName += ' cf-modal--confirm';
    }

    return React.createElement(
      Gateway,
      { into: 'modal' },
      React.createElement(
        ReactCSSTransitionGroup,
        {
          transitionName: 'cf-transition-modal',
          transitionAppear: true,
          transitionAppearTimeout: 200,
          transitionEnterTimeout: 200,
          transitionLeaveTimeout: 200 },
        this.props.isOpen && React.createElement(
          'div',
          { className: 'cf-modal__backdrop-scroller' },
          React.createElement(
            'div',
            { className: 'cf-modal__backdrop-outer' },
            React.createElement(
              ReactModal2,
              {
                ref: 'modal',
                key: 'modal',
                backdropClassName: 'cf-modal__backdrop',
                modalClassName: modalClassName,
                closeOnEsc: this.props.closeOnEsc,
                closeOnBackdropClick: this.props.closeOnBackdropClick,
                onClose: this.props.onRequestClose },
              this.props.children
            )
          )
        )
      )
    );
  };

  return Modal;
}(React.Component);

Modal.propTypes = {
  type: PropTypes.oneOf(['confirm']),
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  closeOnEsc: PropTypes.bool,
  closeOnBackdropClick: PropTypes.bool
};
Modal.defaultProps = {
  closeOnEsc: true,
  closeOnBackdropClick: true
};

module.exports = Modal;